//Get all question for list
const QUESTION_TEMPLATE_GET_DATA = {
  QUESTION_TEMPLATE_GET_DATA_LOAD: "QUESTION_TEMPLATE_GET_DATA_LOAD",
  QUESTION_TEMPLATE_GET_DATA_SUCCESS: "QUESTION_TEMPLATE_GET_DATA_SUCCESS",
  QUESTION_TEMPLATE_GET_DATA_FAIL: "QUESTION_TEMPLATE_GET_DATA_FAIL",
};
const QUESTION_TEMPLATE_GET_DATA_API = "tickets/categories/question-templates";

//Get questions by id
const QUESTION_TEMPLATE_GET_DETAILS_DATA = {
  QUESTION_TEMPLATE_GET_DETAILS_DATA_LOAD: "QUESTION_TEMPLATE_GET_DETAILS_DATA_LOAD",
  QUESTION_TEMPLATE_GET_DETAILS_DATA_SUCCESS: "QUESTION_TEMPLATE_GET_DETAILS_DATA_SUCCESS",
  QUESTION_TEMPLATE_GET_DETAILS_DATA_FAIL: "QUESTION_TEMPLATE_GET_DETAILS_DATA_FAIL",
};
const QUESTION_TEMPLATE_GET_DETAILS_DATA_API = "tickets/categories/question-templates/";

// Add question
const QUESTION_TEMPLATE_FORM_ADD_DATA = {
  QUESTION_TEMPLATE_FORM_ADD_DATA_LOAD: "QUESTION_TEMPLATE_FORM_ADD_DATA_LOAD",
  QUESTION_TEMPLATE_FORM_ADD_DATA_SUCCESS: "QUESTION_TEMPLATE_FORM_ADD_DATA_SUCCESS",
  QUESTION_TEMPLATE_FORM_ADD_DATA_FAIL: "QUESTION_TEMPLATE_FORM_ADD_DATA_FAIL",
};
const QUESTION_TEMPLATE_FORM_POST_API = "tickets/categories/question-templates";

// Update 
const QUESTION_TEMPLATE_FORM_UPDATE_DATA = {
  QUESTION_TEMPLATE_FORM_UPDATE_DATA_LOAD: "QUESTION_TEMPLATE_FORM_UPDATE_DATA_LOAD",
  QUESTION_TEMPLATE_FORM_UPDATE_DATA_SUCCESS: "QUESTION_TEMPLATE_FORM_UPDATE_DATA_SUCCESS",
  QUESTION_TEMPLATE_FORM_UPDATE_DATA_FAIL: "QUESTION_TEMPLATE_FORM_UPDATE_DATA_FAIL",
};

const QUESTION_TEMPLATE_FORM_PUT_API = "tickets/categories/question-templates/";

const QUESTION_TEMPLATE_RESET = "QUESTION_TEMPLATE_RESET";


export{
  
  QUESTION_TEMPLATE_GET_DATA,
  QUESTION_TEMPLATE_GET_DATA_API,
  QUESTION_TEMPLATE_GET_DETAILS_DATA,
  QUESTION_TEMPLATE_GET_DETAILS_DATA_API,
  QUESTION_TEMPLATE_FORM_ADD_DATA,
  QUESTION_TEMPLATE_FORM_POST_API, 
  QUESTION_TEMPLATE_FORM_UPDATE_DATA,
  QUESTION_TEMPLATE_FORM_PUT_API,
  QUESTION_TEMPLATE_RESET,
  
}